import React from 'react';
import './FavoritesPanel.css';

function FavoritesPanel({ isOpen, onClose, favorites = [], onRemove }) {
  if (!isOpen) return null;
  const sorted = [...favorites].sort((a,b) => a.localeCompare(b));
  return (
    <div className="favorites-overlay" onClick={onClose}>
      <div className="favorites-window" onClick={(e) => e.stopPropagation()}>
        <div className="favorites-header">
          <h3>Favorites</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <ul className="favorites-list">
          {sorted.length === 0 && (
            <li className="empty">No favorites yet</li>
          )}
          {sorted.map((item) => (
            <li key={item} className="favorite-item">
              <span className="star">★</span>
              <span className="name">{item}</span>
              <button className="remove-btn" onClick={() => onRemove && onRemove(item)}>Remove</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default FavoritesPanel;


